import React, { HTMLProps, PropsWithChildren } from 'react';
import classNames from 'classnames';
import classes from 'js/components/pipelines/cards/components/NodeBox/NodeBox.module.scss';

export function Footer(props: PropsWithChildren<HTMLProps<HTMLDivElement>>) {
  const { children, className } = props;
  return <div className={classNames(classes.boxFooter, className)}>{children}</div>;
}

Footer.displayName = 'NodeBoxFooter';
